// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message[data-v-0dea2457]{border:1px solid transparent;border-radius:.25rem;list-style:none;margin-bottom:1rem;padding:.75rem 1.25rem;position:relative}.error[data-v-0dea2457]{background-color:#f8d7da;border-color:#f5c6cb;color:#721c24}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
